import {
  DropdownMenuEndAndornment,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "../../../ui/dropdown-menu";
import { LoaderCircle } from "lucide-react";
import { Tooltip } from "../../Tooltip";
import { ActionItemType } from "../types";

export const ActionItem = ({ actionItem }: { actionItem: ActionItemType }) => {
  return (
    <div className="w-full">
      <Tooltip
        content={actionItem.tooltip}
        providerProps={{
          delayDuration: 200,
        }}
        triggerProps={{ asChild: true }}
      >
        <DropdownMenuItem
          className="m-0 rounded-xs py-1.5 px-3 outline-none text-text-interactive-neutral-idle"
          disabled={actionItem.disabled || actionItem.loading}
          onClick={actionItem.onClick}
          onSelect={actionItem.onSelect}
        >
          <div className="flex items-center gap-2 w-full">
            {actionItem.loading && (
              <LoaderCircle className="size-4 motion-preset-spin motion-duration-1000" />
            )}
            {!actionItem.loading && actionItem.icon}
            {actionItem.label}
            {actionItem.endAndornment && (
              <DropdownMenuEndAndornment>
                {actionItem.endAndornment}
              </DropdownMenuEndAndornment>
            )}
          </div>
        </DropdownMenuItem>
      </Tooltip>
      {actionItem.separator && <DropdownMenuSeparator />}
    </div>
  );
};
